<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-container">
      <div v-if="loading" class="loading-state">
        <div class="spinner"></div>
        <p>Đang tải dữ liệu...</p>
      </div>
      <div class="modal-header">
        <h2>Chỉnh sửa tài khoản</h2>
        <button @click="$emit('close')" class="btn-close">
          <i class="icon-x"></i>
        </button>
      </div>

      <form @submit.prevent="handleSubmit" class="modal-body">
        <div class="form-group full-width">
          <label>Ảnh đại diện</label>
          <div class="avatar-upload">
            <div class="avatar-preview">
              <img v-if="previewUrl" :src="previewUrl" alt="Preview" />
              <div v-else class="avatar-placeholder">
                <i class="icon-user"></i>
              </div>
            </div>
            <div class="upload-actions">
              <input
                type="file"
                ref="fileInput"
                @change="handleFileChange"
                accept="image/*"
                hidden
              />
              <button
                type="button"
                @click="$refs.fileInput.click()"
                class="btn btn-outline btn-sm"
              >
                Chọn ảnh
              </button>
              <p class="upload-hint">JPG, PNG tối đa 2MB</p>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="">Tên</label>
          <input v-model="form.name" type="text" value="" />
        </div>
        <div class="form-group">
          <label for="">Username</label>
          <input v-model="form.username" type="text" />
        </div>
        <div class="form-group">
          <label for="">Email</label>
          <input v-model="form.email" type="email" />
        </div>
        <div class="form-group">
          <label for="">Phone</label>
          <input v-model="form.phone" type="text" />
        </div>
        <div class="form-group">
          <label for="">Role</label>
          <input v-model="form.role" type="text" />
        </div>
        <div class="form-group">
          <label for="">Status</label>
          <select v-model="form.status" name="" id="">
            <option value="active">Đang hoạt động</option>
            <option value="inactive">Không hoạt động</option>
            <option value="suspended">Tạm ngưng</option>
          </select>
        </div>
      </form>

      <div class="modal-footer">
        <button @click="$emit('close')" class="btn btn-outline">Hủy</button>
        <button @click="handleSubmit" class="btn btn-primary">Cập nhật</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useToast } from "@/composables/useToast";
import { adminApi } from "@/services/api";
import { onUnmounted, reactive, ref, toRefs, watch } from "vue";

const props = defineProps({
  user: Object,
});
const { user } = toRefs(props);
const loading = ref(false);
const toast = useToast();
const fileInput = ref(null);
const previewUrl = ref("");
const emit = defineEmits(["close", "updated"]);
const form = reactive({
  name: "",
  username: "",
  email: "",
  phone: "",
  status: "",
  role: "",
  avatar: null,
});
onUnmounted(() => {
  if (previewUrl.value) URL.revokeObjectURL(previewUrl.value);
});
watch(
  () => props.user,
  (newUser) => {
    if (newUser) {
      Object.keys(form).forEach((key) => {
        if (key !== "avatar") {
          form[key] = newUser[key] || "";
        }
      });
      form.avatar = null;
      previewUrl.value = "";
    }
  },
  { immediate: true },
);
const handleFileChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    if (file.size > 2 * 1024 * 1024) {
      toast.error("File không được vượt quá 2MB");
      return;
    }

    form.avatar = file;
    previewUrl.value = URL.createObjectURL(file);
  }
};
const handleSubmit = async () => {
  loading.value = true;
  try {
    const userID = user.value.id;
    const originalData = props.user;
    const formData = new FormData();
    let hasChanged = false;

    Object.keys(form).forEach((key) => {
      if (key !== "avatar" && form[key] != originalData[key]) {
        formData.append(key, form[key] ?? "");
        hasChanged = true;
      }
    });
    if (form.avatar instanceof File) {
      formData.append("avatar", form.avatar);
      hasChanged = true;
    }
    if (!hasChanged && !formData.avatar) {
      toast.info("Không có thay đổi nào để cập nhật");
      return;
    }
    await adminApi.updateUser(userID, formData);
    emit("updated");
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Có lỗi xảy ra";
    toast.error(errorMessage);
    console.log(error);
  } finally {
    loading.value = false;
  }
};
</script>
